export default {
    data() {
        return {
            cardListErrors: [
                { error: "The holder_name field is required.", translate: 'Necessário o nome do titular'},
                { error: "Card expired.", translate: 'Cartão Vencido'},
                { error: "CVV is Required", translate: 'Necessário número do CVV'},
                { error: "The number field is not a valid card number", translate: 'Número de cartão inválido'},

            ]
        }

    },
    methods: {
        findErrorMessage(message){
            let backMessage = message
            this.cardListErrors.forEach(value => {
                if(value.error === message){
                    backMessage = value.translate

                }

            });

            return backMessage
        }
    }
}
